import i18n from 'i18next'
import Backend from 'i18next-xhr-backend'
import { initReactI18next } from 'react-i18next'
import { i18nResources } from '@heeros/react-sdk'

import * as moment from 'moment'
import 'moment/locale/fi'
import 'moment/locale/nl'

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en-US',
    load: 'currentOnly',
    backend: {
      loadPath: 'locales/{{lng}}/{{ns}}.json'
    },
    partialBundledLanguages: true,
    resources: i18nResources,

    ns: ['common'],
    defaultNS: 'common',

    debug: false,

    interpolation: {
      escapeValue: false // not needed for react!!
    },

    react: {
      wait: true
    }
  })

i18n.on('languageChanged', languageCode => {
  const [locale] = languageCode.split('-')
  moment.locale(locale)
})

export default i18n
